import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faEnvelopeOpenText } from '@fortawesome/free-solid-svg-icons';
import { Badge, Button, PageShell, Panel } from '../design-system';
import '../components/Auth/AuthSurface.css';

function AutoLoginSentPage(): React.ReactElement {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email');
  const sessionId = searchParams.get('session_id');
  const loginParams = new URLSearchParams({ source: 'auto_login_sent' });

  if (email) {
    loginParams.set('login_hint', email);
  }

  return (
    <PageShell className="auth-page" innerClassName="auth-page__inner" aria-label="Login link sent">
      <div className="auth-status-layout">
        <Panel className="auth-status-panel">
          <div className="auth-status-copy">
            <span className="auth-status-icon" aria-hidden="true">
              <FontAwesomeIcon icon={faEnvelopeOpenText} />
            </span>
            <Badge variant="success">
              <FontAwesomeIcon icon={faCheckCircle} /> Link sent
            </Badge>
            <h1>Check Your Email</h1>
            <p>
              We sent a login link{email ? ' to ' : '.'}
              {email && <span className="auth-status-email">{email}</span>}
            </p>
          </div>

          <div className="auth-status-list">
            <span>Open the message from BotSpot</span>
            <span>Use the link within 5 minutes</span>
            <span>Return here if you need to sign in another way</span>
          </div>

          <div className="auth-status-actions">
            <Button as={Link} to={`/login?${loginParams.toString()}`} variant="outline">
              Manual Login
            </Button>
            <Button as={Link} to="/dashboard" variant="primary">
              Go to Dashboard
            </Button>
          </div>

          {process.env.NODE_ENV === 'development' && sessionId && (
            <div className="auth-debug-note">
              Session ID: {sessionId}
            </div>
          )}
        </Panel>
      </div>
    </PageShell>
  );
}

export default AutoLoginSentPage;
